import { useQuery } from '@tanstack/react-query'
import { useCurrentNetwork } from '@mysten/dapp-kit-react'

import { useBackendClient } from '@/shared/kai/contexts/BackendClientContext'
import { GetVaultMetricsHistoryIntervalType } from '@/shared/backend/types'

export const savMetricsHistoryQueryKey = (
  network: string,
  vaultId: string,
  interval: GetVaultMetricsHistoryIntervalType
) => ['sav-metrics-history', network, vaultId, interval] as const

export const useSAVMetricsHistory = (vaultId: string, interval: GetVaultMetricsHistoryIntervalType) => {
  const network = useCurrentNetwork()

  const backendClient = useBackendClient()

  const result = useQuery({
    queryKey: savMetricsHistoryQueryKey(network, vaultId, interval),
    queryFn: async () => {
      return await backendClient.getSavMetricsHistory(vaultId, interval)
    },
    refetchInterval: 30 * 1000,
  })

  return {
    isLoading: result.isLoading,
    isError: result.isError,
    data: result.data,
    refetch: result.refetch,
  }
}
